// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.Controlled.Input {
  display: block;
  margin: 8px 0;
  position: relative;
  width: 100%;
  height: 32px;
  color: #002E33;
}
div.Controlled.Input > span.Label {
  position: absolute;
  width: 50%;
  text-overflow: ellipsis;
  height: 100%;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  line-height: 32px;
  font-weight: 700;
  font-size: 12px;
  color: #002E33;
  overflow: hidden;
  white-space: nowrap;
}
div.Controlled.Input > span.Label + .Controlled {
  width: 50%;
  margin-left: 50%;
}
div.Controlled.Input > span.Label + .Controlled.CheckBoxInput {
  margin-left: 225px;
}
div.Controlled.Input.withStartAdornment .startAdornment {
  position: absolute;
  font-size: 14px;
  line-height: 14px;
  padding: 12px 8px;
  margin-top: 1px;
  margin-left: 1px;
  background-color: #F5F6F9;
}
div.Controlled.Input.withStartAdornment input {
  padding-left: 40px !important;
}
div.Controlled.Input.AreaInput {
  height: 128px;
}
div.Controlled.Input.LabelOnTop {
  height: 64px;
}
div.Controlled.Input.AreaInput.LabelOnTop {
  height: 96px;
}
div.Controlled.Input.AreaInput .counter {
  font-weight: 500;
}
div.Controlled.Input.Input .counter {
  font-weight: 500;
}
div.Controlled.Input.LabelOnTop span.Label {
  position: relative;
  width: 100%;
  margin-left: 0;
}
div.Controlled.Input.LabelOnTop .Input {
  width: 100% !important;
  margin-left: 0 !important;
  height: 32px;
  display: block;
}
div.Controlled.Input.JustifyLeft .Input {
  text-align: left !important;
}
div.Controlled.Input.LabelOnTop.AreaInput .Input {
  height: 64px;
}
div.Controlled.Input input.Controlled,
div.Controlled.Input textarea.Controlled {
  height: 100%;
  width: 100%;
  margin-left: 0;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  font-family: "Aeonik", sans-serif;
  border: 1px solid #D3D6DF;
  padding: 4px;
  border-radius: 3px;
  font-size: 12px;
  line-height: 16px;
  color: #002E33;
  resize: none;
}
div.Controlled.Input input.Controlled::-webkit-input-placeholder, div.Controlled.Input textarea.Controlled::-webkit-input-placeholder {
  color: #A7A9B4;
}
div.Controlled.Input input.Controlled::-moz-placeholder, div.Controlled.Input textarea.Controlled::-moz-placeholder {
  color: #A7A9B4;
}
div.Controlled.Input input.Controlled:-ms-input-placeholder, div.Controlled.Input textarea.Controlled:-ms-input-placeholder {
  color: #A7A9B4;
}
div.Controlled.Input input.Controlled::-ms-input-placeholder, div.Controlled.Input textarea.Controlled::-ms-input-placeholder {
  color: #A7A9B4;
}
div.Controlled.Input input.Controlled::placeholder,
div.Controlled.Input textarea.Controlled::placeholder {
  color: #A7A9B4;
}
div.Controlled.Input input.Controlled:focus,
div.Controlled.Input textarea.Controlled:focus {
  border: 1px solid #01FF94;
  outline: none;
}
div.Controlled.Input input.Controlled.Borderless,
div.Controlled.Input textarea.Controlled.Borderless {
  border: 1px solid transparent;
  background: transparent;
  padding-left: 0;
}
div.Controlled.Input input.Controlled.Borderless:focus,
div.Controlled.Input textarea.Controlled.Borderless:focus {
  border: 1px solid transparent;
}
div.Controlled.Input input.Controlled.Number,
div.Controlled.Input textarea.Controlled.Number {
  text-align: right;
}
div.Controlled.Input.invalid input.Controlled,
div.Controlled.Input.invalid textarea.Controlled {
  border: 1px solid #D92D20;
  background-color: #FFF8F6;
}
div.Controlled.Input.invalid div.Controlled div.Controlled textarea.Controlled {
  border: 1px solid #D92D20 !important;
}
div.Controlled.Input.FreeTextInput.invalid {
  border: none;
}
div.Controlled.Input.FreeTextInput.invalid .freeTextControl.focus {
  border: none;
}

div.Panel div.Controlled.Input {
  height: auto;
}
div.Panel div.Controlled.Input > span.Label {
  display: block;
  position: relative;
  width: 100%;
}
div.Panel div.Controlled.Input > span.Label + .Controlled {
  width: 100%;
  margin-left: 0;
}

table {
  border-spacing: 0;
}

td {
  padding: 0;
}
td > div {
  margin: 0 !important;
}
td > div > input,
td > div > div {
  border-radius: 0 !important;
}

div.tight div.Controlled.Input {
  margin: 0;
}

div.tight div.Controlled input,
div.tight div.Controlled > div {
  border-radius: 0 !important;
}

div.tight > div:first-child > div.Controlled input,
div.tight > div:first-child > div.Controlled div {
  border-radius: 3px 3px 0 0 !important;
}

div.tight > div:last-child > div.Controlled input,
div.tight > div:last-child > div.Controlled div {
  border-bottom-left-radius: 3px !important;
  border-bottom-right-radius: 3px !important;
}

.withBorder {
  border-radius: 2px;
  border: solid 1px #E8E9F0;
  background-color: #FFF;
}

.absolute {
  position: absolute;
}
.absolute > span {
  margin: 0px !important;
}
.absolute > span > span {
  margin: 0px !important;
}`, "",{"version":3,"sources":["webpack://./src/client/components/common/Input/Input.scss","webpack://./src/client/Global/InputBase.scss","webpack://./src/client/Global/Colors.scss"],"names":[],"mappings":"AAGA;ECiBE,cAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,YAvBY;EAwBZ,cCvBa;AFKf;ACoBE;EArBA,kBAAA;EACA,UALW;EAMX,uBAAA;EACA,YAAA;EACA,8BAAA;UAAA,sBAAA;EACA,iBAVY;EAWZ,gBAAA;EACA,eAAA;EACA,cCZa;EDab,gBAAA;EACA,mBAAA;ADIF;ACWE;EACE,UA9BS;EA+BT,gBA/BS;ADsBb;ACYE;EACE,kBAAA;ADVJ;AApBI;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBE4CG;AFtBT;AAnBI;EACE,6BAAA;AAqBN;AAjBE;EACE,aAAA;AAmBJ;AAhBE;EACE,YAAA;AAkBJ;AAfE;EACE,YAAA;AAiBJ;AAdE;EACE,gBAAA;AAgBJ;AAbE;EACE,gBAAA;AAeJ;AAZE;EACE,kBAAA;EACA,WAAA;EACA,cAAA;AAcJ;AAXE;EACE,sBAAA;EACA,yBAAA;EACA,YClDU;EDmDV,cAAA;AAaJ;AAVE;EACE,2BAAA;AAYJ;AATE;EACE,YAAA;AAWJ;AARE;;ECrBA,YAAA;EACA,WAAA;EACA,cAAA;EACA,8BAAA;UAAA,sBAAA;EACA,iCAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cClDa;EFoEX,YAAA;AAgBJ;AApBI;EACE,cEbG;AFoCT;AAxBI;EACE,cEbG;AFoCT;AAxBI;EACE,cEbG;AFoCT;AAxBI;EACE,cEbG;AFoCT;AAxBI;;EACE,cEbG;AFoCT;AAlBI;;EACE,yBAAA;EACA,aAAA;AAqBN;AAlBI;;EACE,6BAAA;EACA,uBAAA;EACA,eAAA;AAqBN;AAnBM;;EACE,6BAAA;AAsBR;AAlBI;;EACE,iBAAA;AAqBN;AAfI;;EAEE,yBAAA;EACA,yBEhDC;AFiEP;AAdI;EACE,oCAAA;AAgBN;AAZE;EACE,YAAA;AAcJ;AAZI;EACE,YAAA;AAcN;;AATA;EACE,YAAA;AAYF;AAVE;EACE,cAAA;EACA,kBAAA;EACA,WAAA;AAYJ;AATE;EACE,WAAA;EACA,cAAA;AAWJ;;AAPA;EACE,iBAAA;AAUF;;AAPA;EACE,UAAA;AAUF;AARE;EAOE,oBAAA;AAIJ;AATI;;EAEE,2BAAA;AAWN;;AAJA;EACE,SAAA;AAOF;;AAJA;;EAEE,2BAAA;AAOF;;AAJA;;EAEE,qCAAA;AAOF;;AAJA;;EAEE,yCAAA;EACA,0CAAA;AAOF;;AAJA;EACE,kBAAA;EACA,yBAAA;EACA,sBElKM;AFyKR;;AAJA;EACE,kBAAA;AAOF;AALE;EACE,sBAAA;AAOJ;AALI;EACE,sBAAA;AAON","sourcesContent":["@import \"../../../Global/InputBase\";\n@import \"../../../Global/Colors.scss\";\n\ndiv.Controlled.Input {\n  @include inputContainerRules;\n\n  &.withStartAdornment {\n    .startAdornment {\n      position: absolute;\n      font-size: 14px;\n      line-height: 14px;\n      padding: 12px 8px;\n      margin-top: 1px;\n      margin-left: 1px;\n      background-color: $Gray20;\n    }\n\n    input {\n      padding-left: 40px !important;\n    }\n  }\n\n  &.AreaInput {\n    height: $inputHeight * 4;\n  }\n\n  &.LabelOnTop {\n    height: $inputHeight * 2;\n  }\n\n  &.AreaInput.LabelOnTop {\n    height: $inputHeight * 3;\n  }\n\n  &.AreaInput .counter {\n    font-weight: 500;\n  }\n\n  &.Input .counter {\n    font-weight: 500;\n  }\n\n  &.LabelOnTop span.Label {\n    position: relative;\n    width: 100%;\n    margin-left: 0;\n  }\n\n  &.LabelOnTop .Input {\n    width: 100% !important;\n    margin-left: 0 !important;\n    height: $inputHeight;\n    display: block;\n  }\n\n  &.JustifyLeft .Input {\n    text-align: left !important;\n  }\n\n  &.LabelOnTop.AreaInput .Input {\n    height: $inputHeight * 2;\n  }\n\n  input.Controlled,\n  textarea.Controlled {\n    @include inputInputRules;\n    &::placeholder {\n      color: $Gray60;\n    }\n\n    resize: none;\n\n    &:focus {\n      border: 1px solid $ElectricGreen;\n      outline: none;\n    }\n\n    &.Borderless {\n      border: 1px solid transparent;\n      background: transparent;\n      padding-left: 0;\n\n      &:focus {\n        border: 1px solid transparent;\n      }\n    }\n\n    &.Number {\n      text-align: right;\n    }\n  }\n\n  &.invalid {\n\n    input.Controlled,\n    textarea.Controlled {\n      border: 1px solid $Red;\n      background-color: $Red5;\n    }\n\n    div.Controlled div.Controlled textarea.Controlled {\n      border: 1px solid $Red !important;\n    }\n  }\n\n  &.FreeTextInput.invalid {\n    border: none;\n\n    .freeTextControl.focus {\n      border: none;\n    }\n  }\n}\n\ndiv.Panel div.Controlled.Input {\n  height: auto;\n\n  >span.Label {\n    display: block;\n    position: relative;\n    width: 100%;\n  }\n\n  >span.Label+.Controlled {\n    width: 100%;\n    margin-left: 0;\n  }\n}\n\ntable {\n  border-spacing: 0;\n}\n\ntd {\n  padding: 0;\n\n  >div {\n\n    >input,\n    >div {\n      border-radius: 0 !important;\n    }\n\n    margin: 0 !important;\n  }\n}\n\ndiv.tight div.Controlled.Input {\n  margin: 0;\n}\n\ndiv.tight div.Controlled input,\ndiv.tight div.Controlled>div {\n  border-radius: 0 !important;\n}\n\ndiv.tight>div:first-child>div.Controlled input,\ndiv.tight>div:first-child>div.Controlled div {\n  border-radius: 3px 3px 0 0 !important;\n}\n\ndiv.tight>div:last-child>div.Controlled input,\ndiv.tight>div:last-child>div.Controlled div {\n  border-bottom-left-radius: 3px !important;\n  border-bottom-right-radius: 3px !important;\n}\n\n.withBorder {\n  border-radius: 2px;\n  border: solid 1px $Gray30;\n  background-color: $White;\n}\n\n.absolute {\n  position: absolute;\n\n  > span {\n    margin: 0px !important;\n\n    > span {\n      margin: 0px !important;\n    }\n  }\n\n}\n","@import '../Global/Colors';\n$inputHeight: 32px;\n$inputWidth: 50%;\n\n\n@mixin inputLabelRules {\n  position: absolute;\n  width: $inputWidth;\n  text-overflow: ellipsis;\n  height: 100%;\n  box-sizing: border-box;\n  line-height: $inputHeight;\n  font-weight: 700;\n  font-size: 12px;\n  color: $DeepSeaGreen;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n@mixin inputContainerRules {\n  display: block;\n  margin: 8px 0;\n  position: relative;\n  width: 100%;\n  height: $inputHeight;\n  color: $DeepSeaGreen;\n\n  > span.Label {\n    @include inputLabelRules;\n  }\n\n  > span.Label + .Controlled {\n    width: $inputWidth;\n    margin-left: $inputWidth;\n  }\n\n  > span.Label + .Controlled.CheckBoxInput {\n    margin-left: 225px;\n  }\n}\n\n@mixin inputInputRules {\n  height: 100%;\n  width: 100%;\n  margin-left: 0;\n  box-sizing: border-box;\n  font-family: \"Aeonik\", sans-serif;\n  border: 1px solid $Gray50;\n  padding: 4px;\n  border-radius: 3px;\n  font-size: 12px;\n  line-height: 16px;\n  color: $DeepSeaGreen;\n}\n","// Brand\n$ElectricGreen: #01FF94;\n$DeepSeaGreen: #002E33;\n$Lavender: #DBD4FF;\n$DayGrey: #EDF1F7;\n\n// Primary\n$Black: #000;\n$White: #FFF;\n$Green: #00E383;\n$Yellow: #FBDB3F;\n$Red: #D92D20;\n$Purple: #5E46D2;\n\n// Blues\n$Blue140: #131C3E;\n$Blue120: #1E267D;\n$Blue110: #2258CE;\n$Blue90: #5E8BEF;\n$Blue60: #7CA2F8;\n$Blue10: #D0E6FE;\n$Blue5: #E4F1FF;\n\n// Purples\n$Purple140: #5D4DAE;\n$Purple20: #F8F6FF;\n\n// Greens\n$Green140: #075E42;\n$Green120: #078E64;\n$Green110: #29B574;\n$Green90: #32D583;\n$Green60: #6CE9A6;\n$Green20: #BAEFCB;\n$Green10: #DDF3E4;\n$Green5: #E8FFF0;\n\n// Yellows\n$Yellow220: #735714;\n$Yellow200: #8F7638;\n$Yellow120: #DCB11A;\n$Yellow30: #FFF8B8;\n$Yellow10: #FFF9CC;\n\n// Reds\n$Red120: #951307;\n$Red110: #C94337;\n$Red90: #F07B70;\n$Red10: #F7DDD9;\n$Red5: #FFF8F6;\n\n// Grays\n$Gray200: #26282F;\n$Gray90: #697588;\n$Gray60: #A7A9B4;\n$Gray50: #D3D6DF;\n$Gray40: #D9DCE5;\n$Gray30: #E8E9F0;\n$Gray20: #F5F6F9;\n$Gray10: #F6F9FF;\n\n// Legacy color variables: Remove these after deprecating @zervant/reactcomponents package\n$shadowColor: #5F6766;\n$normalTextColor: $Gray200;\n$normalBorderColor: $Gray30;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
